import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/IS_Planner_vertical.png'


const _withScopeId = n => (_pushScopeId("data-v-01a97108"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "initform--background data--center" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "initform__card initform__card__size data--center"
}
const _hoisted_3 = { class: "initform__wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "initform__logo",
  src: _imports_0
}, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "initform__card registerform__card__size data--center"
}
const _hoisted_6 = {
  key: 2,
  class: "initform__card registerform__card__size data--center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_process2fa = _resolveComponent("process2fa")!
  const _component_LoginUserForm = _resolveComponent("LoginUserForm")!
  const _component_RecoverUserPwdForm = _resolveComponent("RecoverUserPwdForm")!
  const _component_RegisterUserForm = _resolveComponent("RegisterUserForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_process2fa),
    (_ctx.loginUserFormStatusData === _ctx.LoginUserFormStatus.Login)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_LoginUserForm)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loginUserFormStatusData === _ctx.LoginUserFormStatus.RecoverUserPwd)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_RecoverUserPwdForm)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loginUserFormStatusData === _ctx.LoginUserFormStatus.RegisterUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_RegisterUserForm)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}